import React, { useState, useEffect } from 'react'
import { useCountry } from '../../../CustomHooks/useCountry';
import { useStateMaster } from '../../../CustomHooks/useStateMaster';
import { nearbyresource } from '../../../services/chatFlowService';
import { addSiteAddress, Addsitedetails, getSiteAddressById, updateSiteAddress, Updatesitedetails } from '../../../services/configurationServices';
import { SuccessToast } from '../../../CustomHooks/SuccessToast';
import { ErrorToast } from '../../../CustomHooks/ErrorToast';
import { useSiteById } from '../../../CustomHooks/useSiteById';

const ZoneAdditionForm = ({ setShowAddSite, showAddSite, site, selectedRow, selectedSite, handleApplyFilters, fetchFilters }) => {

    const [zoneName, setZoneName] = useState('')
    const [zoneNameError, setZoneNameError] = useState("")
    const [branchName, setBranchName] = useState("");
    const [branchNameError, setBranchNameError] = useState("");
    const [siteAddressObj, setSiteAddressObj] = useState(null);
    const [selectedZone, setSelectedZone] = useState(null)

    // console.log("Check selectedSite", selectedSite)
    // console.log("Check selectedZone",selectedZone)
    // console.log("Check selectedRow", selectedRow)

    const { site: parentSite, getSite } = useSiteById()
    const { country } = useCountry()
    const { state, getState } = useStateMaster()

    // console.log("selectedSite", selectedSite)
    useEffect(() => {
      // console.log("SelectedSite", selectedRow)
      if(selectedRow != null){
        setZoneName(selectedRow?.ZoneName)
        // setBranchName(selectedRow?.BranchID)
        getState(selectedRow.countrymasterid)
        setSelectedZone(selectedRow)
      }else{
        if(selectedSite != null){
          // console.log("SelectedSite", selectedSite)
          getSite(selectedSite?.value) // For Adding of new zone to call get site
        }
      }
    }, [selectedRow, selectedSite])

    useEffect(() => {
      if(parentSite.length > 0){
        // console.log("SelectedSite", parentSite)
        getAddressDetails(parentSite[0]?.SiteID)
      }
    }, [parentSite])

    const getAddressDetails = (id) => {
      getSiteAddressById(id)
        .then((res) => {
          if(res.Status == "success"){
            // console.log("SelectedSite", res.Data)
            setSiteAddressObj(res.Data)
            getState(res.Data[0].Countryid)
            let obj = {
              ...res.Data[0],
              ...parentSite[0]
            }
            setSelectedZone(obj)
          }
        }).catch(err => console.log(err))
    }


    const onSaveZone = async () => {
        let isValidate = false
    
        if (zoneName === "") {
          setZoneNameError("Please enter zone name!")
          isValidate = true;
        }
    
        // if(branchName === ""){
        //   setBranchNameError("Please enter branch id!")
        //   isValidate = true;
        // }
    
        if(isValidate){
          return;
        }
    
        let user = JSON.parse(localStorage.getItem("user"));
        var _lat = 0;
        var _long = 0;
        var objNearByResources = {
          SearchPlace: selectedZone?.Address,
          radius: 0,
          lat: 0,
          long: 0,
          SearchType: "PlaceDetails",
        };
        await nearbyresource(objNearByResources).then((resp1) => {
          if (resp1.status == "Ok") {
            if (resp1.message.length > 0) {
              _lat = resp1.message[0].siteLattitude;
              _long = resp1.message[0].siteLongitude;
            }
          }
        });
        if (selectedRow == null) {
          let addZoneObj = {
            UserID: user.Id,
            ParentID: selectedZone?.SiteID.toString(),
            SiteName: zoneName.toString().trim(),
            Lattitude: _lat.toString(),
            Longitude: _long.toString(),
            PinUrl: "",
            Alt: "",
            IsBingMap: "",
            BranchID: selectedZone?.BranchID.toString().trim(), //Keeping it empty.
            SolID: "",
            SiteModeID: selectedZone?.SiteModeID.toString(),
            SiteTypeID: "3", //Zone
            TopicArn: "",
            ClientId:(selectedZone?.clientID && selectedZone?.clientID.toString()) || (selectedZone?.ClientId && selectedZone?.ClientId.toString()),
            OrganizationMasterID: user.OrganizationMasterID.toString(),
          }
          addSiteDetails(addZoneObj, 
            selectedZone?.Address, 
            selectedZone?.CountryId || selectedZone?.Countryid, 
            selectedZone?.StateId || selectedZone?.Stateid, 
            selectedZone?.Region, 
            selectedZone?.Area, 
            selectedZone?.City, 
            selectedZone?.PinCode, 
            user, 
            zoneName, 
            selectedZone?.BranchID, 
            selectedZone?.clientID || selectedZone?.ClientId, 
            selectedZone?.SiteModeID)
        } else {
          let updateZoneObj = {
            UserID: user.Id,
            SiteID: selectedZone.ZoneID?.toString(),
            ParentID: selectedZone.SiteID.toString(),
            SiteName: zoneName.toString().trim(),
            Lattitude: _lat.toString(),
            Longitude: _long.toString(),
            PinUrl: "",
            Alt: "",
            IsBingMap: "",
            BranchID: selectedZone?.BranchID.toString().trim(),
            SolID: "",
            SiteModeID: selectedZone?.SiteModeID.toString(),
            SiteTypeID: "3", //Zone
            TopicArn: "",
            ClientId: (selectedZone?.clientID && selectedZone?.clientID.toString()) || (selectedZone?.ClientId && selectedZone?.ClientId.toString()),
            OrganizationMasterID: user.OrganizationMasterID.toString(),
            CreatedOn: "",
            CreatedBy: "",
            ModifiedOn: "",
            ModifiedBy: user.Id,
            UpdatedateTime: "",
          }
          updateSiteDetails(
            updateZoneObj,
            selectedZone?.AddressId, // Will need the site address id.
            selectedZone?.Address,
            selectedZone?.countrymasterid, 
            selectedZone?.statemasterid, 
            selectedZone?.Region, 
            selectedZone?.Area, 
            selectedZone?.City, 
            selectedZone?.PinCode,
            user
          );
        }
      }

      const addSiteDetails = (
          siteObj,
          siteaddress,
          tempCountryName,
          tempCountryStateName,
          siteRegionName,
          siteaArea,
          cityName,
          sitePincode,
          user,
          sitename,
          branchid,
          clientID,
          SiteModeID
        ) => {
          Addsitedetails(siteObj).then((resp) => {
            if (resp.Status == "success") {
              //Here to add in site address table.
              let addressObj = {
                Siteid: resp.Data.SiteID.toString(),
                Address: siteaddress.toString().trim(),
                Countryid: tempCountryName.toString(),
                Stateid: tempCountryStateName.toString(),
                Region: siteRegionName.toString().trim(),
                Area: siteaArea.toString().trim(),
                City: cityName.toString().trim(),
                PinCode: sitePincode,
                CreatedOn: "",
                ModifiedON: "",
                Createdby: user.Id,
                ModifiedBy: "",
                OrganizationMasterID: user.OrganizationMasterID.toString(),
                UpdatedateTime: "",
                UserID:user.Id
              };
              addSiteAddress(addressObj).then((res) => {
                if (res.Status == "success") {
                  // SuccessToast(resp.Message);
                  SuccessToast('zone added successfully.')
                  clearForm();
                  handleApplyFilters();
                  fetchFilters()
                } else {
                  ErrorToast(resp.Message);
                }
              });
            } else {
              ErrorToast(resp.Message);
            }
          });
        };

        const updateSiteDetails = (
            updateObj,
            siteaddressId,
            siteaddress,
            tempCountryName,
            tempCountryStateName,
            siteRegionName,
            siteaArea,
            cityName,
            sitePincode,
            user
          ) => {
            Updatesitedetails(updateObj).then((resp) => {
              if (resp.Status == "success") {
                let updateAddressObj = {
                  AddressId: siteaddressId.toString(),
                  Siteid: resp.Data.SiteID.toString(),
                  Address: siteaddress.toString().trim(),
                  Countryid: tempCountryName.toString(),
                  Stateid: tempCountryStateName.toString(),
                  Region: siteRegionName.toString().trim(),
                  Area: siteaArea.toString().trim(),
                  City: cityName.toString().trim(),
                  PinCode: sitePincode,
                  CreatedOn: "",
                  ModifiedON: "",
                  Createdby: "",
                  ModifiedBy: user.Id,
                  OrganizationMasterID: user.OrganizationMasterID.toString(),
                  UpdatedateTime: "",
                  UserID:user.Id
                };
                updateSiteAddress(updateAddressObj).then((res) => {
                  if (res.Status == "success") {
                    // SuccessToast(resp.Message);
                    SuccessToast('Zone update Successfully.')
                    handleApplyFilters();
                    fetchFilters()
                  } else {
                    ErrorToast(resp.Message);
                  }
                });
              } else {
                ErrorToast(resp.Message);
                // setButtonDisable(false);
              }
            });
          };

        const clearForm = () => {
    setZoneName('')
    setZoneNameError('')
    // setBranchName('');
    // setBranchNameError('')
    // setIsFormEdit(false)
    // setSelectedZone(null)
  }

    return (
        <div className="SiteMainContainer SiteTableMainDiv p-2">
            <h5> {selectedRow == null ? 'Add' : 'Edit' } zone</h5>
            {/* Add your form components here */}
            <div className='SiteFormAdditionForm'>
                <form style={{ width: "100%" }}>
                    <div className="site-form">
                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Zone Name*</label>
                                <input
                                    className="inputType"
                                    placeholder="Zone Name"
                                    value={zoneName}
                                    onChange={(e) => {
                                        setZoneName(e.target.value)
                                        setZoneNameError("")
                                    }}

                                />
                                <p className="Error_P" style={{ float: "left" }}><span>{zoneNameError}</span></p>
                            </div>
                        </div>

                          <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Branch ID</label>
                                <input
                                    className="inputType"
                                    placeholder="Branch Id"
                                    value={selectedZone?.BranchID}
                                    disabled
                                    // value={branchName}
                                    // onChange={(e) => {
                                    //     setBranchName(e.target.value)
                                    //     setBranchNameError("")
                                    // }}
                                />
                                <p className="Error_P" style={{ float: "left" }}><span>{}</span></p>
                            </div>
                        </div>

                        {/* <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Latitude</label>
                                <input
                                    className="inputType"
                                    placeholder="Latitude"
                                    disabled={true}
                                    value={parentSite?.Lattitude}
                                />
                                <p className="Error_P" style={{ float: "left" }}><span></span></p>
                            </div>
                        </div> */}

                        {/* <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Longitude</label>
                                <input
                                    className="inputType"
                                    placeholder="Longitude"
                                    disabled={true}
                                    value={parentSite?.Longitude}
                                />
                                <p className="Error_P" style={{ float: "left" }}><span></span></p>
                            </div>
                        </div> */}

                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Address One</label>
                                <input
                                    className="inputType"
                                    placeholder="Address One"
                                    disabled={true}
                                    value={selectedZone?.Address}
                                />
                                <p className="Error_P" style={{ float: "left" }}><span></span></p>
                            </div>
                        </div>
                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Select Region</label>
                                <input
                                    className="inputType"
                                    placeholder="Region"
                                    disabled={true}
                                    value={selectedZone?.Region}
                                />
                                <p className="Error_P" style={{ float: "left" }}><span></span></p>
                            </div>
                        </div>

                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Select Area</label>
                                <input
                                    className="inputType"
                                    placeholder="Area"
                                    disabled={true}
                                    value={selectedZone?.Area}
                                />
                                <p className="Error_P" style={{ float: "left" }}><span></span></p>
                            </div>
                        </div>

                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Select Country</label>
                                <select className="inputType ArrowSelectClass" disabled={true} value={selectedZone?.countrymasterid || selectedZone?.Countryid}>
                                    <option key="0" disabled={false} value="0" id="0">Select Country*</option>
                                    {country &&
                                        country.map((val) => (
                                            <option value={val.countrymasterid} key={val.countrymasterid} id={val.countrymasterid}>
                                                {val.countryname}
                                            </option>
                                        ))}
                                </select>
                                <p className="Error_P" style={{ float: "left" }}><span> </span></p>
                            </div>
                        </div>

                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Select State</label>
                                <select className="inputType ArrowSelectClass" disabled={true} value={selectedZone?.statemasterid || selectedZone?.Stateid}>
                                    <option key="0" disabled={false} value="0">Select State*</option>
                                    {state &&
                                        state.map((val) => (
                                            <option value={val.statemasterid} key={val.statemasterid}>
                                                {val.statename}
                                            </option>
                                        ))}
                                </select>
                                <p className="Error_P" style={{ float: "left" }}><span></span></p>
                            </div>
                        </div>

                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Select City</label>
                                <input
                                    className="inputType"
                                    placeholder="Select City*"
                                    value={selectedZone?.City}
                                    disabled={true}
                                />
                                <p className="Error_P" style={{ float: "left" }}><span></span></p>
                            </div>
                        </div>


                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Pin Code</label>
                                <input
                                    className="inputType"
                                    placeholder="Pin code"
                                    disabled={true}
                                    value={selectedZone?.PinCode}
                                />
                                <p className="Error_P" style={{ float: "left" }}><span></span></p>
                            </div>
                        </div>

                    </div>
                </form>
            </div>
            <div style={{ textAlign: "center" }}>
                <button className="DataAccessEdit" style={{ width: "100px" }} onClick={onSaveZone}>
                    <span className="ViewUpdate">Save</span>
                </button>
                <button className="DataAccessEdit" style={{ width: "100px" }} onClick={() => setShowAddSite(false)}>
                    <span className="ViewUpdate">Cancel</span>
                </button>
            </div>
        </div>
    )
}

export default ZoneAdditionForm